import React from 'react';
import { NavLink } from "react-router-dom";
import './Menu.css'

function Menu () {
    

    
        return (
            <div>
                <div className="">
    <div className="sidebarWrapper">

        {/* Menu */}
        <div className="sidebarMenu">

            <ul className="sidebarMenuList">
              <NavLink to="/dashboard" >
                <li className="sidebarMenuItem active">
                   

                    <div className="sidebarMenuLeft">
                        <i className="fa-solid fa-table-cells-large sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Tổng quan</span>
                    </div>
                    
                </li>
                </NavLink>

                <NavLink to="/khu-cong-nghiep" >
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-building sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Khu công nghiệp</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>

                <NavLink to="/doanh-nghiep" >
                
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-building-columns sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Doanh nghiệp</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>


                    <NavLink to="/dau-tu">
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-solid fa-landmark sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Đầu tư</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                    </NavLink>

                <NavLink to="/dat-dai">
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-map sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Đất đai</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>

                <NavLink to="/ha-tang">
                
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-solid fa-network-wired sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Hạ tầng</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>


                <NavLink to="/moi-truong">
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-leaf sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Môi trường</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>


            <NavLink to="/lao-dong">
            
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-user sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Lao động</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
            </NavLink>

                <NavLink to="/dich-vu-cong">
                
                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-circle-dot sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Dịch vụ công</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>
                </NavLink>

                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-solid fa-chart-column sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Báo cáo - Thống kê</span>
                    </div>

                    <i className="fa-solid fa-angle-right sidebarArrow"></i>
                </li>

                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-regular fa-bell sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Cảnh báo</span>
                    </div>
                </li>

                <li className="sidebarMenuItem">
                    <div className="sidebarMenuLeft">
                        <i className="fa-solid fa-gear sidebarMenuIcon"></i>
                        <span className="sidebarMenuText">Hệ thống</span>
                    </div>
                </li>

            </ul>
        </div>


        {/* Card bottom */}
        <div className="sidebarCard">

            <img
                src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=1200&auto=format&fit=crop"
                alt=""
                className="sidebarCardImage"
            />

            <h3 className="sidebarCardTitle">
                Ban quản lý
                <br />
                khu kinh tế tỉnh An Giang
            </h3>

            <p className="sidebarCardAddress">
                Số 531 Nguyễn Trung Trực, P. Rạch giá, Tỉnh An giang
            </p>

            <div className="sidebarCardInfo">
                <i className="fa-solid fa-phone"></i>
                <span>0919 466 308</span>
            </div>

            <div className="sidebarCardInfo">
                <i className="fa-solid fa-envelope"></i>
                <span>bqlkkt@angiang.gov.vn</span>
            </div>

            <div className="sidebarCardInfo">
                <i className="fa-solid fa-globe"></i>
                <span>https://bqlkkt.angiang.gov.vn</span>
            </div>

        </div>

    </div>
</div>
            </div>
        );
    
}



export default Menu;